<template lang='pug'>
  .articles#articles-listing
    template(v-if='articlesLoading && !insantSearch()')
      .articles-loader
        .loader-spinner

    template(v-else)
      template(v-if='searchPage && pageLoaded')
        back-icon(v-if='isMobile')
        .search-results-title(v-t='"faq.searchResults"')
        .total-search-results(v-if='articles')
          template(v-if='articlesCount === 0')
            p(v-t='{ path: "faq.noSearchResults", args: { query: $route.query.q } }')
          template(v-else)
            p(v-t='{ path: "faq.totalSearchResults", args: { total: articlesCount, query: $route.query.q } }')
            .article-line

      .article(v-for='article in articles', :key='article.id')
        .row(@click='gotoArticle(article)')
          .col-11
            .article-title(v-text='article.name')
          .col-1
            .svg-icon.chevron-right.right-arrow
        .article-line

    template(v-if='articlesCount > 0')
      .articles-pagination
        pagination(:full='true' :startPage='articlesPage' :pageCount='articlesPageCount' scrollTo='#articles-listing' :scrollOffset='-120' @setPage='setPage')
</template>

<i18n>
{
  "lng_en": {
    "faq": {
      "searchMessage": "Search FAQ",
      "searchResults": "Search Results",
      "totalSearchResults": "%{total} results found for “%{query}”",
      "noSearchResults": "No results found for “%{query}”"
    }
  },
  "lng_id": {
    "faq": {
      "searchMessage": "Cari FAQ",
      "searchResults": "Hasil Pencarian",
      "totalSearchResults": "%{total} hasil ditemukan untuk “%{query}”",
      "noSearchResults": "Tidak ada hasil ditemukan untuk “%{query}”"
    }
  },
  "lng_th": {
    "faq": {
      "searchMessage": "ค้นหา FAQ",
      "searchResults": "ผลของการค้นหา",
      "totalSearchResults": "%{total} พบผลลัพธ์สำหรับ “%{query}”",
      "noSearchResults": "ไม่พบผลลัพธ์สำหรับ “%{query}”"
    }
  },
  "lng_zh": {
    "faq": {
      "searchMessage": "搜尋常見問題",
      "searchResults": "搜尋結果",
      "totalSearchResults": "“%{query}”有 %{total}項搜尋結果",
      "noSearchResults": "沒有找到關於“%{query}”的結果"
    }
  },
  "lng_ko": {
    "faq": {
      "searchMessage": "자주 묻는 질문 검색",
      "searchResults": "검색 결과",
      "totalSearchResults": "“%{query}“에 대한 검색 결과 %{total}건",
      "noSearchResults": "“%{query}”에 대한 검색 결과가 없습니다"
    }
  }
}
</i18n>

<script>
import UrlMixin from './url-mixin'
import BackIcon from './back-icon.vue'
import ArticleShow from './article-show.vue'
import Pagination from '../shared/pagination.vue'
import { fullUrl } from '@/modules/services/utilities'
import { createNamespacedHelpers } from 'vuex'
const { mapState, mapGetters, mapMutations, mapActions } = createNamespacedHelpers('faq')

export default {
  components: {
    BackIcon,
    ArticleShow,
    Pagination
  },

  data () {
    return {
      pageLoaded: false
    }
  },

  computed: {
    ...mapGetters(['objectBySlug']),

    ...mapState({
      sections: state => state.sections,
      articles: state => state.articles,
      focusSearch: state => state.focusSearch,
      focusSearchQuery: state => state.searchQuery,
      articlesLoading: state => state.articlesLoading,
      articlesPage: state => state.page,
      articlesCount: state => state.count
    }),

    isMobile: () => vueSupport.isMobile,

    searchPage () {
      return this.$route.meta.entityType === 'search'
    },

    articlesPageCount () {
      return Math.ceil(this.articlesCount / 10)
    }
  },

  mounted () {
    if (this.searchPage) {
      this.fetchData()
      this.$store.commit('setSeoMetaTitle', this.$t('faq.searchMessage'))
      this.$store.commit('setSeoOgUrl', fullUrl(this.$route.path))
      this.$store.commit('setSeoUpdate', true)
    }
  },

  methods: {
    ...mapActions(['fetchArticles']),

    ...mapMutations([
      'setSearchQuery',
      'setArticlesPage'
    ]),

    gotoArticle (article) {
      this.$router.push({ name: 'faq-article-show',
        params: {
          sectionId: UrlMixin.getSlug(this.objectBySlug('sections', String(article.section_id))),
          articleId: UrlMixin.getSlug(article) }
      })
    },

    insantSearch () {
      return this.focusSearch && this.focusSearchQuery.length > 0
    },

    fetchData () {
      if (this.searchPage) {
        this.setSearchQuery(this.$route.query.q)
        this.fetchArticles(this.$route.query.q).then(() => {
          this.pageLoaded = true
        })
      } else {
        this.fetchArticles()
      }
    },

    setPage (page) {
      this.setArticlesPage(page)
      this.fetchData()
    }
  }
}
</script>

<style lang='scss' scoped>
  .articles-loader {
    display: flex;
    justify-content: center;
    min-height: 400px;
    padding-top: 40px;
  }

  .search-results-title {
    @include font-weight-bold;
    font-size: 20px;
    text-transform: uppercase;
    border-bottom: 1px solid $black;
    padding-bottom: 8px;
  }

  .total-search-results {
    @include font-weight-bold;
    margin-top: 14px;
    margin-bottom: 10px;
  }

  .row {
    cursor: pointer;
    margin-top: 17px;
  }

  .col-1 {
    @include media-breakpoint-down(md) {
      margin-left: -17px;
    }
  }

  .article-line {
    height: 1px;
    margin-top: 8px;
    background-color: $grey;
  }

  .right-arrow {
    height: 20px;
    width: 20px;
  }

  .articles-pagination {
    margin-top: 30px;
  }
</style>
